import React, { forwardRef } from 'react';
import styles from './Card.module.css';

type CardProps = {
  children?: React.ReactNode;
  style?: React.CSSProperties;
} & React.HTMLAttributes<HTMLDivElement>;

type CardHeaderProps = {
  title: string;
  children?: React.ReactNode;
} & React.HTMLAttributes<HTMLDivElement>;

type CardBodyProps = {
  children?: React.ReactNode;
} & React.HTMLAttributes<HTMLDivElement>;

type CardFooterProps = {
  children?: React.ReactNode;
} & React.HTMLAttributes<HTMLDivElement>;

const CardHeader = ({ title, children, ...props }: CardHeaderProps) => {
  return (
    <div className={styles.header} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '12px' }} {...props}>
      <h3 className={styles.title} style={{ flex: 1, minWidth: 0, margin: 0 }}>{title}</h3>
      {children && (
        <div style={{ display: 'flex', gap: '8px', flexShrink: 0, alignItems: 'center' }}>
          {children}
        </div>
      )}
    </div>
  );
};

const CardBody = ({ children, ...props }: CardBodyProps) => {
  return (
    <div className={styles.body} {...props}>
      {children}
    </div>
  );
};

const CardFooter = ({ children, ...props }: CardFooterProps) => {
  return (
    <div className={styles.footer} {...props}>
      {children}
    </div>
  );
};

type CardComponent = React.ForwardRefExoticComponent<CardProps & React.RefAttributes<HTMLDivElement>> & {
  Header: React.FC<CardHeaderProps>;
  Body: React.FC<CardBodyProps>;
  Footer: React.FC<CardFooterProps>;
};

const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ children, style, ...props }, ref) => {
    return (
      <div ref={ref} className={styles.container} style={style} {...props}>
        {children}
      </div>
    );
  },
) as CardComponent;

Card.Header = CardHeader;
Card.Body = CardBody;
Card.Footer = CardFooter;
Card.displayName = 'Card';

export default Card;
